<script>
    import { onMount } from "svelte";
    import { withResolvers } from "@otto-ec/assets-core-utils/promise";
    import Cinema from "../components/Cinema.svelte";
    import { getAggregationFeatureLabels, getFeatureOrder } from "../utils/externalTrackingHelper.js";

    let { data } = $props();
    const {
        headline,
        recommendations,
        tracking,
        additionalClickTracking,
        metaData,
        featuresState,
        hasPersonalisedRecommendations = false,
        index = 0,
    } = data;

    let cinemaInjectionContainerWidth = $state(1000);
    let featureIndex = $state("99");
    let additionalTrackingLabels = $state(null);
    const [cinemaContainerMounted, mountSuccess] = withResolvers();

    let cinemaContainer;

    onMount(() => {
        featureIndex = getFeatureOrder(cinemaContainer);
        additionalTrackingLabels = getAggregationFeatureLabels(cinemaContainer);
        cinemaInjectionContainerWidth = parseInt(cinemaContainer?.offsetWidth) || 1000;
        mountSuccess();
    });
</script>

<div bind:this={cinemaContainer}>
    <div class="reco_storefront_cinema_wrapper">
        <Cinema
            {headline}
            {recommendations}
            {tracking}
            {featureIndex}
            {additionalClickTracking}
            {additionalTrackingLabels}
            {cinemaInjectionContainerWidth}
            cinemaIndex={index}
            cinemaMeta={metaData}
            {featuresState}
            site="reco_reco_Storefront"
            personalisedUser={hasPersonalisedRecommendations}
            {cinemaContainerMounted}
        />
    </div>
</div>

<style lang="scss">
    .reco_storefront_cinema_wrapper {
        min-height: 360px;
        max-height: 672px;
        position: relative;
    }
</style>
